import api from 'Application/api/api';

const deleteProjectPhoto = (projectId, cancelToken = null) =>
    api.delete(`project-manager/projects/${projectId}/photo`, { cancelToken });

export default deleteProjectPhoto;
